/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';

import _ = require("lodash");
import { DAYS_OF_WEEK, WORKOUT_FOCUS_TYPE } from "../../../../containers/FitnessPlan/constants";
import { IMicrocycleError } from "../../../../containers/FitnessPlan/FitnessTemplate/interface";
import { CustomPopover } from "../../../common/CustomPopover/CustomPopover";


interface IMicrocyleTemplateProps {
    editMode?: boolean;
    selectedDay: number;
    groupedPrewods: any;
    setSelectedDay: (day: number) => void;
    setWorkoutFocus: (selectedFocus: string) => void;
    errorStates: IMicrocycleError[];
    isViewMode: boolean;
}

export const MicrocyleDayTab: React.FC<IMicrocyleTemplateProps> = (props: IMicrocyleTemplateProps) => {
    const { groupedPrewods, selectedDay, setSelectedDay, setWorkoutFocus, errorStates, isViewMode } = props;

    const getDropdownOptions = () => {
        const options = [...WORKOUT_FOCUS_TYPE];

        //to get list of days which has workut defined so that it can be copied
        let copiedFromDays = Object.values(groupedPrewods).map((preWod: any, index) => {
            const currentPreWod = preWod[0];
            if (currentPreWod.workoutType && currentPreWod.dayOfCycle != selectedDay) {
                const day = _.find(DAYS_OF_WEEK, { internalValue: currentPreWod.dayOfCycle });
                return ({ displayValue: `${day.displayValue} : ${preWod[0].workoutType}`, internalValue: day.internalValue });

            }
        }).filter(Boolean);

        if (copiedFromDays && copiedFromDays.length > 0) {
            options.push({
                displayValue: "Copy From", internalValue: "copy", children: copiedFromDays
            })
        }
        return options;
    }

    return (
        <div css={styles.daysWrapper}>
            {
                DAYS_OF_WEEK.map((day, index) => {
                    const preWodData = groupedPrewods && groupedPrewods[day.internalValue] && groupedPrewods[day.internalValue][0];
                    const isSelected = selectedDay === day.internalValue;
                    const focusLabel = preWodData && preWodData.workoutType ? preWodData.workoutType : "Add Focus";
                    const focusLabelStyle = preWodData && preWodData.workoutType ? styles.dayFocusType({ isSelected }) : styles.addDayFocus({ isSelected });
                    const dayHasError = errorStates && errorStates.find(errorDay => errorDay.day === day.internalValue);
                    return (
                        <div css={styles.dayBlock({ isSelected, showError: dayHasError })} key={`day-${index}-${selectedDay}`} onClick={() => setSelectedDay(day.internalValue)}>
                            <div css={styles.dayName({ isSelected, showError: dayHasError })}>{day.displayValue}</div>
                            {!isViewMode ?
                                <CustomPopover dropdownOptions={getDropdownOptions()}
                                    clickLabel={focusLabel}
                                    clickLabelStyles={focusLabelStyle}
                                    showTooltipIcon={true}
                                    handleOptionSelection={setWorkoutFocus}
                                    selectedOption={preWodData && preWodData.workoutType}
                                    popoverPlacement='bottom'
                                />
                                : <div css={styles.dayFocusType({ isSelected, isViewMode })}>{preWodData && preWodData.workoutType ? preWodData.workoutType : "-"}</div>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}